import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HttpRequestService } from '../../../utilities/http/request.utilities';
import {ReactiveFormsModule } from '@angular/forms';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { UserState } from '../../../store/user/user.model';
import { firstValueFrom } from 'rxjs';


@Component({
  selector: 'app-use-resources',
  standalone: true,
  templateUrl: './use-resources.component.html',
  styleUrls: ['./use-resources.component.css'],
  imports: [CommonModule, MatDialogModule, MatSelectModule, MatIconModule, ReactiveFormsModule,NgxMatSelectSearchModule ],
})
export class UseResourcesComponent implements OnInit {
  modelsWithResources: string[] = [];
  allResources: any[] = [];
  filteredResources: any[] = [];
  selectedModelTo: string | null = null;
  selectedModelFrom: string | null = null;
  public message: string = '';
  isSuccess: boolean = false;

  modelControl = new FormControl('');
  modelFilterCtrl = new FormControl('');
  filteredModels: string[] = [];
  
  selectedManualType: string | null = null;
  manualTypeControl = new FormControl('');
  manualTypeFilterCtrl = new FormControl('');
  ManualTypes: string[] = []; 
  filteredManualTypes: string[] = [];
  
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { 
      make: string;
      model: string;
    },
    private dialogRef: MatDialogRef<UseResourcesComponent>,
    private httpRequestService: HttpRequestService,
    private cdr: ChangeDetectorRef,
    private store: Store<{ user: UserState }>

  ) {}

  ngOnInit(): void {
    this.fetchResources(); 
    this.modelFilterCtrl.valueChanges.subscribe((search: string | null ) => {
    const searchValue = search?.toLowerCase() || '';
    this.filteredModels = this.modelsWithResources.filter(model =>
      model.toLowerCase().includes(searchValue)
    );
  });
  }

  fetchResources(): void {
  const endpoint = `${environment.integrations.adminResources}?make=${this.data.make}`;
  this.httpRequestService.request<any>('GET', endpoint).subscribe({
    next: (response) => {
      const items = response.items || [];

      const formattedResources = items
        .filter((item: any) =>
          item.MAKE === this.data.make && Array.isArray(item.Manuals) && item.Manuals.length > 0
        )
        .flatMap((item: any) => {
          const validManuals = item.Manuals.filter((manual: any) =>
            manual.url && manual.url.endsWith('.pdf') &&
            !['Manual not available for Model', 'Manual not available for SN'].includes(manual.url)
          );

          return validManuals.map((manual: any) => ({
            title: manual.title,
            locale: manual.locale,
            manualType: manual.title || '—',
            serialStart: item.StartSerial || 'All',
            serialEnd: item.EndSerial || 'All',
            pvc: item.PVC || '',
            serialExclusions: manual.serialExclusions || '—',
            uploadedAt: new Date(manual.uploaded_at || new Date()).toLocaleDateString(),
            url: manual.url,
            file_name: this.extractPdfName(manual.url) + '.pdf',
            equipment_make: item.MAKE,
            equipment_model: item.Models,
          }));
        });

      this.allResources = formattedResources;

      // Get list of models that have resources
      const modelSet = new Set<string>();
      formattedResources.forEach((r:any)=> modelSet.add(r.equipment_model));
      this.modelsWithResources = Array.from(modelSet);
      this.filteredModels = [...this.modelsWithResources]; 
      this.cdr.detectChanges();
    },
    error: (error) => {
      console.error('Failed to fetch models with resources:', error);
    }
  });
}

  onModelChange(): void {
  const model = this.modelControl.value;
  this.filteredResources = this.allResources.filter(r => r.equipment_model === model);
  this.isSuccess = false;
  this.message = '';
  // if resources are available for filteredModels, fetch manual types too
  this.fetchManualTypes()
  this.manualTypeControl.setValue('All Manuals');
  this.filteredManualTypes = ['All Manuals'];
}

fetchManualTypes(): void {
  const endpoint = `${environment.integrations.modelManualType}?make=${this.data.make}&model=${this.modelControl.value}`;
  this.httpRequestService.request<any>('GET', endpoint).subscribe({
    next: (response) => {
      this.ManualTypes = response.manual_types || []; 
      this.filteredManualTypes = [...this.ManualTypes];
      this.cdr.detectChanges();
    },
    error: (error) => {   
      console.error('Failed to fetch manual types:', error);
    }
  });
}

onManualTypeChange(): void {
  const manualType = this.manualTypeControl.value;  
  if (manualType) {
    this.filteredResources = this.filteredResources.filter(r => r.manualType === manualType);
  }

}
  extractPdfName(url: string): string {
  const match = url.match(/\/([^/]+)\.pdf$/);
  return match ? match[1] : '';
}


 async useResources():  Promise<void> {
    console.log(`Using resources for model ${this.modelControl.value}`);
    this.selectedModelTo = this.data.model;
    this.selectedModelFrom = this.modelControl.value;
    if (this.manualTypeControl.value!='All Manuals') { // only if a specific manual type is selected
      this.selectedManualType = this.manualTypeControl.value;
    }
    const user = await this.getAuthenticatedUsername();
    console.log(`Authenticated user: ${user}`);
    const endpoint = `${environment.integrations.duplicateResources}?make=${this.data.make}&modelFrom=${this.selectedModelFrom}&modelTo=${this.selectedModelTo}&manualType=${encodeURIComponent(this.selectedManualType ?? '')}&user=${user}`;

    this.httpRequestService.request<any>('POST', endpoint, {
      make: this.data.make,
      modelFrom: this.selectedModelFrom,
      modelTo: this.selectedModelTo,
    }).subscribe({
      next: (response) => {
      console.log('Resources used successfully:', response);
      this.message = response?.message || 'Resources duplicated successfully.';
      this.isSuccess = true;

      
      this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Failed to use resources:', error);
        this.message = 'Failed to duplicate resources. Please try again.';
        this.isSuccess = false;
        this.cdr.detectChanges();
      }
    });
  }

  discard(): void {
    this.dialogRef.close();
  }
  closeDialog(): void {
  this.dialogRef.close({
    usedModel: this.modelControl.value,
    resources: this.filteredResources
  });
  
}
  private async getAuthenticatedUsername(): Promise<string> {
    const userState = await firstValueFrom(this.store.select('user'));
    const email = userState.userInfo?.email;
    if (email) {
      return email.split('@')[0];
    }
    return 'anonymous';
  }
}
